import { connect } from 'react-redux';
import { FLAG_VARIABLE_RESOLUTION } from 'constants/FeatureFlags';
import { streamActions, mediaSelectors, callSelectors, initActions, featureSelectors } from '@lifesize/nucleus';
import { VIDEO_FOOTER_PIP, PREVIEW_VIDEO_ID } from 'constants/InCall/InCallVideo';
import SourceDisplay from 'components/SourceDisplay/InCallSourceDisplay';
import _get from 'lodash/get';
import _find from 'lodash/find';

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);

  const videoDevices = mediaSelectors.videoDevices(state) || [];
  const audioDevices = mediaSelectors.audioDevices(state) || [];
  const audioOutputDevices = mediaSelectors.audioOutputDevices(state) || [];

  const primaryVideoSourceId = _get(state, 'nucleus.media.selectedVideoSourceId') || _get(state, 'nucleus.media.primaryVideoSourceId');
  const primaryAudioSourceId = _get(state, 'nucleus.media.selectedAudioSourceId') || _get(state, 'nucleus.media.primaryAudioSourceId');
  const selectedAudioOutputId = _get(state, 'app.media.selectedAudioOutputId') || _get(state, 'nucleus.media.primaryAudioOutputId');
  const selectedVideoSource = _find(videoDevices, { deviceId: primaryVideoSourceId });
  const selectedAudioSource = _find(audioDevices, { deviceId: primaryAudioSourceId });
  const selectedAudioOutputDevice = _find(audioOutputDevices, { deviceId: selectedAudioOutputId });

  const isAudioMuted = _get(activeCall, 'isAudioMuted');
  const isVideoMuted = _get(activeCall, 'isVideoMuted');
  const defaultVideoSetting = !isVideoMuted;
  const defaultAudioSetting = !isAudioMuted;

  const selectedSources = {
    primaryVideoSourceId,
    primaryAudioSourceId,
    primaryAudioOutputId: selectedAudioOutputId
  };

  let selectedVideoLabel = selectedVideoSource ? selectedVideoSource.label : null;
  if (!selectedVideoLabel) {
    selectedVideoLabel = videoDevices.length ? videoDevices[0].label : '';
  }

  let selectedAudioLabel = selectedAudioSource ? selectedAudioSource.label : null;
  if (!selectedAudioLabel) {
    selectedAudioLabel = audioDevices.length ? audioDevices[0].label : '';
  }

  let selectedAudioOutputLabel = selectedAudioOutputDevice ? selectedAudioOutputDevice.label : null;
  if (!selectedAudioOutputLabel) {
    selectedAudioOutputLabel = audioOutputDevices.length ? audioOutputDevices[0].label : '';
  }

  const isWebConferencing = _get(activeCall, 'isWebConferencing');
  const showQualityDropdown = featureSelectors.getFeatureFlag(state)(FLAG_VARIABLE_RESOLUTION);

  return {
    videoDevices,
    audioDevices,
    selectedSources,
    selectedVideoLabel,
    selectedAudioLabel,
    selectedAudioOutputLabel,
    selectedAudioOutputId,
    defaultVideoSetting,
    defaultAudioSetting,
    isWebConferencing,
    isAudioMuted,
    isVideoMuted,
    showQualityDropdown
  };
};

const mapDispatchToProps = dispatch => ({
  acquireLocalPrimaryStream: () => {
    // Workaround until WEBTOP-1306 is implemented
    dispatch(initActions.initialize({
      localPrimaryElementIds: [VIDEO_FOOTER_PIP, PREVIEW_VIDEO_ID]
    }));
  },
  selectVideoSource: (id, sources) => {
    dispatch(streamActions.setPrimaryVideoSourceId(id));
    dispatch(streamActions.setSelectedVideoSourceId(id));
    const setSources = Object.assign(
      {}, sources, { primaryVideoSourceId: id }
    );
    dispatch(streamActions.acquireLocalPrimaryStream(setSources)).then(() => {
      dispatch(streamActions.setSelectedAudioSourceId(setSources.primaryAudioSourceId));
    });
  },
  selectAudioSource: (id, sources) => {
    dispatch(streamActions.setPrimaryAudioSourceId(id));
    dispatch(streamActions.setSelectedAudioSourceId(id));
    const setSources = Object.assign(
      {}, sources, { primaryAudioSourceId: id }
    );
    dispatch(streamActions.acquireLocalPrimaryStream(setSources)).then(() => {
      dispatch(streamActions.setSelectedVideoSourceId(setSources.primaryVideoSourceId));
    });
  },
  selectAudioOutput: id => dispatch(streamActions.setPrimaryAudioOutputId(id))
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (
  Object.assign({}, ownProps, stateProps, dispatchProps,
    {
      selectVideoSource: (id, sources) => {
        dispatchProps.selectVideoSource(id, Object.assign(
          {}, stateProps.selectedSources, sources,
          { audio: !stateProps.isAudioMuted, video: !stateProps.isVideoMuted }
        ));
      },
      selectAudioSource: (id, sources) => {
        dispatchProps.selectAudioSource(id, Object.assign(
          {}, stateProps.selectedSources, sources,
          { audio: !stateProps.isAudioMuted, video: !stateProps.isVideoMuted }
        ));
      }
    })
);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SourceDisplay);
